var popupInit;

(function ($) {

	const selectors = {
		popup: '[data-popup]',
		close: '[data-popup-close]',
		content: '[data-popup-content]',
	}

	popupInit = function () {

		$(selectors.popup).each((i, el) => {
			new Popup(el);
		});

	}

	class Popup {

		constructor(el) {

			this.$popup = $(el);

			if (this.$popup.length) {
				this.init();
				this.bind();
			}
		}

		init() {
			this.id = this.$popup.attr('id');
			this.$content = $(selectors.content, this.$popup);
			this.$closeBtn = $(selectors.close, this.$popup);

			this.$trigger = $('[href="#' + this.id + '"]');

		}
		bind() {

			const self = this;

			this.open = this.open.bind(this);
			this.close = this.close.bind(this);
			this.onTriggerClicked = this.onTriggerClicked.bind(this);

			this.$trigger.on('click', function (e) { self.onTriggerClicked(e, this); });
			this.$popup.on('click', this.close);
			this.$closeBtn.on('click', (e) => { e.preventDefault(); self.close(); });

			this.$content.on('click', (e) => { e.stopPropagation(); });
		}

		onTriggerClicked(e, trigger) {
			e.preventDefault();

			var content = $(trigger).attr('data-popup-form-text') || '';

			$('textarea', this.$content).text(content);

			this.open();

		}

		close() {
			this.$popup.stop().fadeOut();
		}
		open() {
			this.$popup.stop().fadeIn();
		}

	}

})(jQuery);


export default popupInit;